import styled from '@emotion/styled';
import React from 'react';
import { mediaQuery } from 'src/common';
import { Card, Flex, Text } from 'src/components';
import { baseWidths, colors } from 'src/theme';

export interface KPICardProps {
  number: string;
  title: string;
  description: string;
  align?: 'center' | 'flex-start';
}

export const KPICard: React.FC<KPICardProps> = ({
  number,
  title,
  description,
  align = 'center'
}) => (
  <Card background={colors.background6} style={{ boxShadow: 'none', padding: '16px 8px' }}>
    <Flex gap={8} align={align}>
      <Text type="xxLarge" bold>{number}</Text>
      <Flex vertical>
        <Text type="base" bold>{title}</Text>
        <Text type="small">{description}</Text>
      </Flex>
    </Flex>
  </Card>
);

// KPI Container Component
const KPIContainerStyle = styled(Flex)({
  padding: '16px 16px',
  justifyContent: 'center',
  flexWrap: 'nowrap',
  flexDirection: 'column',

  [mediaQuery('laptopL')]: {
    padding: '16px 16px',
    maxWidth: baseWidths.mobile + 900,
    flexDirection: 'row',
  },
});

export interface KPIContainerProps {
  children: React.ReactNode;
}

export const KPIContainer: React.FC<KPIContainerProps> = ({ children }) => (
  <KPIContainerStyle gap={16}>
    {children}
  </KPIContainerStyle>
);
